import { render, staticRenderFns } from "./StudyManagementCandidate.vue?vue&type=template&id=0a6bcdbe&lang=pug"
import script from "./StudyManagementCandidate.vue?vue&type=script&lang=ts"
export * from "./StudyManagementCandidate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports